import React from 'react';
import SignupForm from 'components/auth/signup/form';
import AuthMainLayout from 'layouts/auth-main';
import SignupInfo from 'components/auth/signup/signup-info';

const SignUp = () => {
  return (
    <AuthMainLayout asideChild={<SignupInfo/>}>
      <SignupForm /> {/* No property prop passed */}
    </AuthMainLayout>
  );
};

export default SignUp;
